import { Box, Typography } from '@mui/material'
import { BOARD_CHAR_OPACITY_MIN } from '../../utils/scrollAnimation'

export default function ScrollBoldText({ text, sx = {} }) {
  const chars = text.split('')
  const charColor = sx.color ?? '#000'

  return (
    <Typography
      component="p"
      sx={{
        fontSize: { xs: 18, sm: 24, md: 30, lg: 30 },
        lineHeight: 'normal',
        fontWeight: 400,
        margin: 0,
        ...sx,
      }}
    >
      {chars.map((char, index) => (
        <Box
          component="span"
          key={`${index}-${char}`}
          data-char-index={index}
          sx={{
            opacity: BOARD_CHAR_OPACITY_MIN,
            color: charColor,
          }}
        >
          {char}
        </Box>
      ))}
    </Typography>
  )
}
